import { useEffect, useState } from "react";

/** Hide the previous selection immediately; ignore responses from superseded requests. */
export function useLookup<T>(key: string, fetchValue: () => Promise<T>) {
  const [result, setResult] = useState<{
    key: string;
    value?: T;
    error?: unknown;
  }>({ key: "" });
  useEffect(() => {
    if (!key) {
      setResult({ key: "" });
      return;
    }
    let active = true;
    setResult({ key });
    fetchValue().then(
      (value) => {
        if (active) setResult({ key, value });
      },
      (error) => {
        if (active) setResult({ key, error });
      }
    );
    return () => {
      active = false;
    };
    // The key must include every input to fetchValue. A closure change alone is not a new lookup.
  }, [key]);
  const current = key && result.key === key ? result : null;
  return {
    value: current?.value,
    error: current?.error,
    loading: Boolean(key && !current?.value && !current?.error),
  };
}
